import React from "react";

export const JoiningMeet = () => {
	return <div className="w-full fixed flex flex-row justify-center">
		<div className="w-32rem mt-16 p-16">
			<div className="text-alt-3 text-3xl">Joining Fish Networks ...</div>
		</div>
	</div>

}